<div class="legend-card">
  <ng-container *ngIf="isDeepdiveHardcodedPanel; else defaultPanel">
    <div class="deepdive-card-row">
      <div class="legend-section">
        <div class="legend-title">CONS</div>
        <div class="kpi-divider"></div>
        <div class="kpi-grid">
          <div class="kpi-label">Price increase</div><div class="kpi-value hot">{{ getConsPriceIncrease() }}</div>
          <div class="kpi-label">PPI</div><div class="kpi-value">{{ mappedPriceIncrease }}</div>
          <div class="kpi-subdivider"></div><div class="kpi-subdivider"></div>
          <div class="kpi-label">CAT price realization</div><div class="kpi-value">-4.7%</div>
          <div class="kpi-label">Competitor price realization</div><div class="kpi-value">1.8%</div>
          <div class="kpi-label">Market share</div><div class="kpi-value">34%</div>
          <div class="kpi-label">CAGR</div><div class="kpi-value">2%</div>
          <div class="kpi-label">Sales</div><div class="kpi-value">{{ getConsSales() }}</div>
          <div class="kpi-label">Margin</div><div class="kpi-value">18%</div>
        </div>
      </div>

      <div class="legend-section">
        <div class="legend-title">AGRI</div>
        <div class="kpi-divider"></div>
        <div class="kpi-grid">
          <div class="kpi-label">Price increase</div><div class="kpi-value hot">{{ getAgriPriceIncrease() }}</div>
          <div class="kpi-label">PPI</div><div class="kpi-value">{{ mappedPriceIncrease }}</div>
          <div class="kpi-subdivider"></div><div class="kpi-subdivider"></div>
          <div class="kpi-label">CAT price realization</div><div class="kpi-value">N/A</div>
          <div class="kpi-label">Competitor price realization</div><div class="kpi-value">1.7%</div>
          <div class="kpi-label">Market share</div><div class="kpi-value">5%</div>
          <div class="kpi-label">CAGR</div><div class="kpi-value">5%</div>
          <div class="kpi-label">Sales</div><div class="kpi-value">{{ getAgriSales() }}</div>
          <div class="kpi-label">Margin</div><div class="kpi-value">20%</div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #defaultPanel>
  <ng-container *ngIf="sections.length; else defaultLegendBlock">
    <div class="legend-section" *ngFor="let section of sections">
      <div class="legend-title">{{ section.title }}</div>
      <div class="legend-list">
        <div class="legend-item" *ngFor="let item of section.items">
          <span class="swatch" *ngIf="item.color" [style.border-color]="item.color"></span>
          <span class="text">
            {{ item.title }}
            <span class="desc" *ngIf="item.description"> - {{ item.description }}</span>
          </span>
        </div>
      </div>
      <div class="bubble-scale" *ngIf="section.showBubbleScale">
        <span class="dot d1"></span>
        <span class="dot d2"></span>
        <span class="dot d3"></span>
      </div>
    </div>
  </ng-container>

  <ng-template #defaultLegendBlock>
    <div class="legend-title">{{ data?.title || 'LEGENDS' }}</div>
    <div class="legend-list">
      <div class="legend-item" *ngFor="let item of legendItems">
        <span class="swatch" *ngIf="item.color" [style.border-color]="item.color"></span>
        <span class="text">
          {{ item.title }}
          <span class="desc" *ngIf="item.description"> - {{ item.description }}</span>
        </span>
      </div>
    </div>
    <div class="bubble-scale" *ngIf="data?.title === 'BUBBLE SIZE'">
      <span class="dot d1"></span>
      <span class="dot d2"></span>
      <span class="dot d3"></span>
    </div>
  </ng-template>
  </ng-template>
</div>
